import { render } from "./OConfirmationDialog.vue?vue&type=template&id=d689ba0a&scoped=true"
import script from "./OConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./OConfirmationDialog.vue?vue&type=script&lang=js"

import "./OConfirmationDialog.vue?vue&type=style&index=0&id=d689ba0a&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d689ba0a"]])

export default __exports__